<template>
    <b-container class="pb-2 bg-light mt-2 rounded">
        <light-box :album_id="popupimage"
                   
                   @close="lightboxActive ? lightboxActive = false : ''"
                   ref="lightbox"
                   style="z-index: 9999;"
                   v-if="lightboxActive"/>
        <page-heading heading="Maldives Qualifications Authority" class="pt-2"/>
        <b-col cols="9" class="mx-auto text-left">
        <div class="lead pb-4">
            <span v-html="this.about.value"></span>
        </div>
        <page-heading heading="Vision"/>
        <div class="lead pb-4 text-center">
            <span v-html="this.vision.value"></span>
        </div>
        <page-heading heading="Mission" class="pb-2 pt-2"/>
        <div class="lead pb-4 text-center">
            <span v-html="this.mission.value"></span>
        </div>
        </b-col>
        <b-card no-body>    
        <b-tabs card class="px-0">
            <b-tab v-for="category in categories" :key="category.id" :title="category.name">
                <h3 class="text-center pb-2 font-weight-light">{{category.name}}</h3>
                <b-col class="mx-auto" cols=12>
                    <b-card-group deck class="mx-auto w-100">
                        <div v-for="(member, index) in members" v-if="member.category_id === category.id" :key="member.id" class="my-2">
                            <div v-if="index == index % 2" class="w-100 d-none d-sm-block d-md-none"></div>
                            <div v-if="index == index % 3" class="w-100 d-none d-md-block d-lg-none"></div>
                            <div v-if="index == index % 4" class="w-100 d-none d-lg-block d-xl-none"></div>
                            <div v-if="index == index % 5" class="w-100 d-none d-xl-block"></div>
                            <div class="card shadow-sm text-dark text-center px-0 col-md-12" @click="member.overlay ? selectMember(member.overlay) : false" :style="{'cursor': member.overlay ? 'pointer' : 'default'}" style="max-width: 220px; min-width: 220px">
                                <b-img fluid v-if="member.image" :src="member.image" class="card-img-top mx-auto d-block"></b-img>
                                <b-img fluid v-else src="/static/img/stock-profile.jpg" class="card-img-top mx-auto d-block"></b-img>
                                <h4 class="card-header small text-center"><b>{{member.title + " " + member.name}}</b></h4>
                                <ul class="list-group list-group-flush px-0">
                                    <li class="list-group-item small" v-if="member.position">{{member.position}}</li>
                                    <li class="list-group-item small" v-if="member.email">{{member.email}}</li>
                                    <li class="list-group-item small" v-if="member.phone">{{member.phone}}</li>
                                </ul>
                            </div>
                        </div>
                    </b-card-group>
                </b-col>
            </b-tab>
        </b-tabs>
        </b-card>
        <page-heading heading="Find Us"/>
        <span class="mx-auto d-flex align-items-center justify-content-center pt-3">
        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3979.2484053713624!2d73.50593061527967!3d4.171504747178947!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b3f7e56ee756ab1%3A0x7cc0599fc6f4a614!2sFen%20Building!5e0!3m2!1sen!2smv!4v1609384434866!5m2!1sen!2smv" width="100%" height="450" frameborder="0" style="border:0" allowfullscreen></iframe> 
        </span>
        <page-heading heading="Contact Us"/>
        <b-col class="mx-auto" cols=8 md=9>
            <div class="text-center">
            <span class="unstyled" v-html="this.contactUs.value"></span>
        </div>
        </b-col>
       
    </b-container>
</template>
<script>
import LightBox from "@/components/SharedComponents/LightBox"
import PageHeading from '@/components/SharedComponents/PageHeading'
import axios from 'axios'

export default {
    data() {
        return{
            about: [],
            vision: [],
            mission: [],
            contactUs: [],
            categories: [],
            members:[],
            popupimage: 0,
            lightboxActive: false
        }
    },
    methods: {
        getCategories() {
            axios.get(this.API_URL + '/about/member/categories').then((response) => {
                this.categories = response.data
            }, (error) => {
                console.log(error)
            })
        },

        getAbout() {
            axios.get(this.API_URL + '/about').then((response) => {
                this.about = response.data
            }, (error) => {
                console.log(error)
            })
        },

        getVision() {
            axios.get(this.API_URL + '/about/vision').then((response) => {
                this.vision = response.data
            }, (error) => {
                console.log(error)
            })
        },

        getMission() {
            axios.get(this.API_URL + '/about/mission').then((response) => {
                this.mission = response.data
            }, (error) => {
                console.log(error)
            })
        },

        getContactUs() {
            axios.get(this.API_URL + '/about/contact_us').then((response) => {
                this.contactUs = response.data
            }, (error) => {
                console.log(error)
            })
        },

        getMembers() {
            axios.get(this.API_URL + '/about/members').then((response) => {
                this.members = response.data
                this.members.sort((a, b) => {
                    return a.id - b.id
                })
            }, (error) => {
                console.log(error)
            })
        },

        selectMember(overlay) {
            this.popupimage = overlay
            this.lightboxActive = !this.lightboxActive
            // Delay updating the lightbox image list array
            // because the component is not ready fast enough
            setTimeout( () => {
                this.$refs.lightbox.imageList = [overlay]
            }, (1))
        }
    },
    components: {
        PageHeading,
        LightBox
    },
    computed: {
    },
    beforeCreate() {
        document.title = "About MQA"
    },
    created() {
        
    },
    beforeMount() {
        
    },
    mounted() {
        this.getAbout()
        this.getVision()
        this.getMission()
        this.getContactUs()
        this.getCategories()
        this.getMembers()
    },
    beforeUpdate() {
        
    },
    updated() {

    }
}
</script>
<style scoped>
.hidden {
        z-index: -9999;
    }
</style>



// WEBPACK FOOTER //
// src/components/about.vue